import styled, { CSSProperties } from 'styled-components';

import { BodilColor } from '~src/branding';
import { Button } from '~src/components/Button';
import { Heading, Text } from '~src/components/Typography';

const Box = styled.div({
  padding: '24px',
  width: '451px',
  border: `1px solid ${BodilColor.greyscale[30]}`,
  borderRadius: '10px',
});

type ButtonActionBoxProps = {
  heading: string;
  text: string;
  buttonText: string;
  buttonDisabled?: boolean;
  onClick: () => void | Promise<void>;
  style?: CSSProperties;
};

export const ButtonActionBox = ({
  heading,
  text,
  buttonText,
  buttonDisabled,
  onClick,
  style,
}: ButtonActionBoxProps) => {
  return (
    <Box style={style}>
      <Heading>{heading}</Heading>

      <Text level={2} style={{ marginTop: '24px', lineHeight: '30px', fontWeight: 400 }}>
        {text}
      </Text>

      <Button
        onClick={onClick}
        type='callToAction'
        disabled={buttonDisabled}
        color={BodilColor.ui.orange}
        style={{
          margin: '24px auto 0 auto',
        }}
      >
        {buttonText}
      </Button>
    </Box>
  );
};
